<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="timeWindowCreatePermission" id="page-user-edit">
		<vx-card>
			<time-window-create-tab />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import TimeWindowCreateTab from "./TimeWindowCreateTab.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		TimeWindowCreateTab,
		NotPermission,
	},
	computed: {
		timeWindowCreatePermission() {
			return this.$store.getters.checkPermission("TIME_WINDOW_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
